import { createToast, toastType } from 'Common/ToastHelper';

import { APP_START_UP, APP_UPDATE_AVAILABLE } from './types';
import { getUpdateAvailable } from './selectors';

export const appStartUp = () => ({
  type: APP_START_UP,
});

export const setUpdateAvailable = isAvailable => ({
  type: APP_UPDATE_AVAILABLE,
  payload: isAvailable,
});

export const displayUpdateNotification = () => (dispatch, getState) => {
  const state = getState();

  const updateAvailable = getUpdateAvailable(state);

  if (updateAvailable) {
    /**
     * TODO: Insert additional logic for whether to display toast
     */
    createToast(
      toastType.info,
      null,
      'A new version is available, please refresh to update.',
      false
    );
  }
};



// WEBPACK FOOTER //
// ./src/state/app/actions.js